<template>
  <div>
    <google-geo-point
        :latitude.sync="latitude"
        :longitude.sync="longitude"
        :styles="{
          height: 'calc(100vh - 350px)'
        }"
    />
  </div>
</template>
<script>
/* eslint-disable no-undef */
import GoogleGeoPoint from '@/components/GoogleGeoPoint';

export default {
  name: 'GeoPoint',
  components: { GoogleGeoPoint },
  props: {
    value: {
      required: false,
    },
    structure: {
      type: Object,
      required: true,
    },
    label: {
      type: String,
      default: null,
    },
    errorMessages: {
      type: [Object, Array],
      required: true,
    },
  },
  data() {
    return {
      proxyValue: {
        latitude: null,
        longitude: null,
      },
    };
  },
  computed: {
    latitude: {
      get() {
        if (!this.value || !this.value.geometry || !this.value.geometry.coordinates) {
          return null;
        }
        return this.value.geometry.coordinates[1];
      },
      set(val) {
        this.setProxyValue('latitude', val);
      },
    },
    longitude: {
      get() {
        if (!this.value || !this.value.geometry || !this.value.geometry.coordinates) {
          return null;
        }
        return this.value.geometry.coordinates[0];
      },
      set(val) {
        this.setProxyValue('longitude', val);
      },
    },
  },

  methods: {
    setProxyValue(field, value) {
      this.proxyValue[field] = value;
      if (value && this.proxyValue.latitude && this.proxyValue.longitude) {
        const inputValue = {
          crs: '4326',
          geometry: {
            type: 'Point',
            coordinates: [
              this.proxyValue.longitude,
              this.proxyValue.latitude,
            ],
          },
        };
        this.$emit('input', inputValue);
        this.proxyValue.latitude = null;
        this.proxyValue.longitude = null;
      } else if (!value && !this.proxyValue.latitude && !this.proxyValue.longitude) {
        this.$emit('input', null);
      }
    },
  },
};
</script>
